import { styled } from "@pigment-css/react";
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { ChevronDown } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { TriggerButton } from "../../../DateRangeSelector/DateRangeSelector";
import { DropdownContent, MenuItem } from "../../../DateRangeSelector/DateRangeSelectorDropdown";
import type { ProductGroupRef } from "../productDrill";

const SwitcherTrigger = styled(TriggerButton)({
  maxWidth: "180px",
  minWidth: 0,
});

const TriggerLabel = styled("span")({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

interface LevelSwitcherProps {
  /** The levels above the current one, outermost first; `onSelect` receives an index into this list. */
  levels: ProductGroupRef[];
  onSelect: (depth: number) => void;
}

export const LevelSwitcher = ({ levels, onSelect }: LevelSwitcherProps) => {
  const t = useTranslations();
  const parentName = levels.at(-1)?.name ?? "";

  return (
    <RadixDropdown.Root modal={false}>
      <RadixDropdown.Trigger asChild>
        <SwitcherTrigger type="button" aria-label={`${t("managementView.productGroup.levelSwitcher")}: ${parentName}`}>
          <TriggerLabel>{parentName}</TriggerLabel>
          <ChevronDown />
        </SwitcherTrigger>
      </RadixDropdown.Trigger>
      <RadixDropdown.Portal>
        <DropdownContent align="start">
          {levels.map((level, depth) => (
            <MenuItem key={level.id} onSelect={() => onSelect(depth)}>
              {level.name}
            </MenuItem>
          ))}
        </DropdownContent>
      </RadixDropdown.Portal>
    </RadixDropdown.Root>
  );
};
